/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const listReceivablesResponseItem = zod.object({
  "id": zod.string().uuid(),
  "payerOrganizationId": zod.string().uuid(),
  "payerOrganizationName": zod.string(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "paidDate": zod.string().datetime({}).nullish(),
  "paymentReference": zod.string().nullish()
})
export const listReceivablesResponse = zod.array(listReceivablesResponseItem)

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getReceivableByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getReceivableByIdResponseSourceSourcesItemAddressAddressLine1Max = 255;

export const getReceivableByIdResponseSourceSourcesItemAddressAddressLine2Max = 255;

export const getReceivableByIdResponseSourceSourcesItemAddressCityMax = 255;

export const getReceivableByIdResponseSourceSourcesItemAddressStateMax = 2;

export const getReceivableByIdResponseSourceSourcesItemAddressZipMax = 10;

export const getReceivableByIdResponseSourceSourcesItemAddressCountryMax = 100;



export const getReceivableByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "payerOrganizationId": zod.string().uuid(),
  "payerOrganizationName": zod.string(),
  "payerTimeZoneId": zod.string(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "paidDate": zod.string().datetime({}).nullish(),
  "paymentReference": zod.string().nullish(),
  "earlyDisbursement": zod.object({
  "offer": zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
}),
  "election": zod.object({
  "electedAt": zod.string().datetime({}),
  "electedByUserId": zod.string().uuid().nullish()
}).optional()
}).optional(),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(getReceivableByIdResponseSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getReceivableByIdResponseSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getReceivableByIdResponseSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(getReceivableByIdResponseSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(getReceivableByIdResponseSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(getReceivableByIdResponseSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
}).optional(),
  "payments": zod.array(zod.object({
  "status": zod.string(),
  "isFailed": zod.boolean(),
  "isReturned": zod.boolean(),
  "amount": zod.number(),
  "allocatedAmount": zod.number(),
  "rail": zod.string(),
  "reference": zod.string(),
  "createdDate": zod.string().datetime({}),
  "initiatedDate": zod.string().datetime({}).nullish(),
  "settledDate": zod.string().datetime({}).nullish(),
  "returnedDate": zod.string().datetime({}).nullish(),
  "returnCode": zod.string().nullish(),
  "failureCode": zod.enum(['PayeeIdentityVerificationMissing', 'PayeeIdentitySuspended', 'PayeeBankAccountMissing', 'PayeeBankAccountNotApproved', 'PayeeBankAccountUnderReview', 'PayeeBankAccountRejected', 'PayeeBankAccountUnlinked', 'PayeeBankAccountReturned', 'PayeeCardMissing', 'PayeeCardNotApproved', 'PayeeCardUnderReview', 'PayeeCardRejected', 'PayeeCardNotOctCapable', 'PayeeCardNotDebit', 'PushToCardNotEnabledForOrganization', 'PushToCardNotEnabledForTalentMember', 'PayeeNotTalentMember', 'PayeeTalentMembershipInactive', 'PayerCredentialMissing', 'InsufficientBalance', 'ProviderError', 'ProviderFailure']).optional()
})),
  "invoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}))
})

/**
 * **Required Permission(s):** ORG_RECEIVABLE_ELECT_EARLY_DISBURSEMENT
 */
export const electReceivableEarlyDisbursementParams = zod.object({
  "id": zod.string().uuid()
})

export const electReceivableEarlyDisbursementBody = zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
})

